import React, { type ForwardedRef } from 'react';
import Link from 'components/Globals/Base/Link';
import type { Magazine } from 'interfaces/Taxonomy';
import { NextCustomImage } from 'components/Image';
import { parseCaptionWhenAltTextEmpty } from 'utils/parsingUtils/clientSideParsing';
import type { MediaItem } from 'interfaces/content/Media';
import MagazineListItemWrapper from './magazineListItemStyles';

function isMediaItem(image: MediaItem | string | null): image is MediaItem {
  if (!image) return false;
  return (image as MediaItem).mediaItemUrl !== undefined;
}

const MagazinesListItem = React.forwardRef(
  ({ title, image, uri }: Magazine, ref: ForwardedRef<HTMLDivElement> | null) => {
    const ariaLabelText = isMediaItem(image) && image.altText ? image.altText : title;

    return (
      <MagazineListItemWrapper ref={ref}>
        <Link
          href={uri}
          ariaLabel={ariaLabelText}
        >
          {isMediaItem(image) && (
            <NextCustomImage
              width='225'
              height='300'
              src={`${image.mediaItemUrl.split('?')[0]}?w=700`}
              alt={parseCaptionWhenAltTextEmpty(image)}
            />
          )}
        </Link>
        <Link
          href={uri}
          className='title'
        >
          {title}
        </Link>
      </MagazineListItemWrapper>
    );
  },
);

export default MagazinesListItem;
